import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function OurCLientTwo() {
    return (
        <Container>
            <Row>
                <Col className='about-one-title' > Our Clients </Col>
            </Row>
            <Row className='text-center' >
                <Col>
                    <h3 className='about-one-h'>We connect the world with a high level of security and safety therefore, we are the NO.1 CCTV camera installation provider. </h3>
                </Col>
            </Row>
            <Row >
                <Col className='text-center'>
                    <p className='about-one-p text-center' >
                        Royality Technologies will provide all your security needs with advanced security solutions. We are the best security camera installation and service provider company in Hyderabad that fits modern security requirements.
                    </p>
                </Col>
            </Row>

           
        </Container>
    )
}

export default OurCLientTwo